





















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

import fieldIcon from './field-icon.vue';
import { CustomFieldList } from '@/config/custom.conf.ts';
import { Container, Draggable } from 'vue-smooth-dnd';
import * as api from '@/api';

import eventBus from '@/utils/event-bus';
import store from '@/store';

/**
 * 自定义字段展示列表
 *
 * @author liyuyao
 * @date 03/12/2020
 */
@Component({
    components: {
        Container,
        Draggable,
        fieldIcon
    }
})
export default class FieldShow extends Vue {
    @State(state => state.cti.systemFields)
    systemFields: CommonTypes.mapObject[];

    @Prop({
        default: () => {
            return [];
        }
    })
    totalFields: CommonTypes.mapObject[];

    fieldType: string = 'customField';
    // systemFieldList: CommonTypes.customField[] = [];
    customFieldList: CommonTypes.customField[] = [];
    thirdFieldDialogVisible: boolean = false;
    thirdFieldLoading: boolean = false;
    thirdFieldList: any[] = [];
    currentPage: number = 1;
    pageSize: number = 10;
    totalCount: number = 0;

    mounted() {
        this.customFieldList = CustomFieldList.map(field => {
            return Object.assign(field, {
                type: 2,
                defaultValue: '',
                isRequired: false,
                isHidden: false,
                instruction: ''
            });
        });
    }

    handleClose() {
        this.$emit('close');
    }

    getChildPayload(index) {
        return this.FieldList[index];
    }

    addFieldToSchema(field) {
        eventBus.$emit('clickAddField', field);
        this.handleClose();
    }

    openThirdFieldDialog() {
        this.thirdFieldDialogVisible = true;
        this.currentPage = 1;
        this.fetchThirdFields();
    }

    async fetchThirdFields() {
        this.thirdFieldLoading = true;
        try {
            const rgId = parseInt(this.$route.query.rgId as string, 10);
            const res = await api.rgApi.getThirdFormList1({
                rgId,
                cn: this.currentPage,
                sn: this.pageSize
            });

            if (res.code === 200) {
                this.thirdFieldList = res.data.items || [];
                this.totalCount = res.data.tn || 0;
            } else {
                this.$mtd.message.error('获取三方字段失败');
            }
        } catch (e) {
            console.error('获取三方字段失败', e);
            this.$mtd.message.error('获取三方字段失败');
        } finally {
            this.thirdFieldLoading = false;
        }
    }

    handlePageChange(page) {
        this.currentPage = page;
        this.fetchThirdFields();
    }

    /**
     * @deprecated 未使用.
     */
    getFieldTypeName(type) {
        const typeMap = {
            SINGLE_LINE_TEXT: '单行文本',
            MULTI_LINE_TEXT: '多行文本',
            SINGLE_DROPDOWN: '单选下拉框',
            MULTI_DROPDOWN: '多选下拉框'
        };
        return typeMap[type] || type;
    }

    addThirdField(field) {
        // 将三方字段转换为自定义表单可用的格式
        const customField = {
            id: field.id,
            name: '',
            instruction: '',
            type: 3, // 3表示三方集成字段类型
            component: 'componentThirdField',
            inputType: 'THIRD_FIELD',
            defaultValue: [],
            isRequired: false,
            isHidden: false
        };

        eventBus.$emit('clickAddField', customField);
        this.thirdFieldDialogVisible = false;
        this.handleClose();
    }

    get systemFieldList() {
        const existSys = this.totalFields.filter(sys => sys.type === 1).map(sys => sys.identify);
        return this.systemFields.filter(field => {
            return !existSys.includes(field.identify);
        });
    }

    get FieldList() {
        return this.fieldType === 'systemField' ? this.systemFieldList : this.customFieldList;
    }
}
